import axios from "axios";
import config from "@/config";
import SessionUtil from "@/utils/SessionUtil";
import moment from "moment";
import {showDialog, showToast} from "vant";
import CommonUtil from "@/utils/CommonUtil";

export default {
    getPublic() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/return-trip/public', {
                headers: {}
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, orders: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getOrders() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/return-trip/list', {
                headers: {}
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, orders: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    getStatus() {
        return new Promise(function (resolve, reject) {
            axios.get(config.api + '/return-trip/status', {
                headers: {},
                params: {
                    coordinateType: "GCJ02",
                },
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, status: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    cancel(order_number) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/return-trip/cancel', null, {
                headers: {},
                params: {
                    order_number: order_number
                },
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, code: rs.code});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    publish(orderData) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/return-trip/publish', orderData, {
                headers: {},
                params: {},
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, orderId: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    payment(orderData) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/return-trip/payment', orderData, {
                headers: {},
                params: {},
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, orderId: rs.data});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
    applyOrder(orderData) {
        return new Promise(function (resolve, reject) {
            axios.post(config.api + '/return-trip/apply-order', orderData, {
                headers: {},
                params: {},
            }).then(function (response) {
                const rs = response.data;
                if (rs.code === 200) {
                    resolve({response: response, success: true, code: rs.code});
                } else {
                    resolve({response: response, success: false});
                }
            }).catch(function (error) {
                reject(error);
            });
        });
    },
}